import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/uq7WfowEuzVbUusYK65x4m/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/eA4vnbGdSD9Kch6uDwhVqT/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/ihTKe2P39rC63kYWETZ3ky/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/kf2XxdLi9mqta2mrPpZgFb/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/eN4BZ65JbfAnLUV7pyhPgm/pasted-image.png'];
export function SuccessStories() {
  return <section className="py-24 bg-transparent overflow-hidden border-t border-white/5 pt-[18px] pb-[18px]" data-id="element-188" data-mp="36vv6hogvx3to">
      <div className="max-w-7xl mx-auto px-4 mb-20 text-center" data-id="element-189" data-mp="31tw86t004x3l">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#ec4899]/10 border border-[#ec4899]/30 text-[#ec4899] text-sm font-black mb-8 tracking-widest" data-id="element-190" data-mp="2wx5o7ul2thcw">
          ✨ RESULTADOS DE ALUMNOS
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-7xl font-black text-white mb-8 tracking-tight leading-tight" data-id="element-191" data-mp="1qpzv5d4obash">
          DE CERO A <br data-id="element-192" data-mp="1lry1xzdj9v3a" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#ec4899] drop-shadow-[0_0_20px_rgba(236,72,153,0.3)]" data-id="element-193" data-mp="1lsrczcjiz6r8">
            PROFESIONAL
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl text-gray-400 max-w-3xl mx-auto font-medium" data-id="element-194" data-mp="1cvys476ov1mb">
          Mirá lo que están logrando personas que empezaron sin saber nada de
          electricidad ni diseño.
        </motion.p>
      </div>

      <div className="max-w-4xl mx-auto px-4 flex flex-col gap-16" data-id="element-195" data-mp="a68s6n5e0yat">
        {IMAGES.map((src, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative w-full aspect-square rounded-[3rem] overflow-hidden border border-white/10 group shadow-[0_0_50px_rgba(0,0,0,0.5)]" data-id="element-196" data-mp="58h1fwghbi87" data-mpi={index}>
            <div className="relative group" data-id="element-197" data-mp="38mbgx82jm8vh">
              <div className="absolute -inset-4 bg-gradient-to-r from-[#00f0ff]/20 to-[#ec4899]/20 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-198" data-mp="38ppg67fwu1yp" />
              <div className="relative rounded-[3rem] overflow-hidden border border-white/10 shadow-2xl aspect-square" data-id="element-199" data-mp="1t2c6tnziqpay">
                <img src={src} alt={`Proyecto de alumno Neon Flex ${index + 1}`} width={800} height={800} decoding="async" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-200" data-mp="22u86h3h96nha" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a0b2e] via-transparent to-transparent opacity-60" data-id="element-201" data-mp="2grwn1z4af8gj" />
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-32 text-center" data-id="element-202" data-mp="mib899sxafel">
        <p className="text-gray-500 font-black italic text-2xl tracking-wide" data-id="element-203" data-mp="re9ryk3b398o">
          "EL PRÓXIMO CARTEL PUEDE SER EL TUYO..."
        </p>
      </div>
    </section>;
}